/**
 * Только чтение — соседняя глава в стеке свайпа (без тапов и тулбара).
 */
export default function BfChapterPreview({ verses = [] }) {
  if (!verses.length) return null;

  return (
    <>
      {verses.map((verseItem) => (
        <div key={verseItem.verse} className="verse-item">
          <div className="bf-verse-stack">
            <div className="bf-verse" data-active="false" data-saved="false">
              <sup className="bf-verse__num" aria-hidden="true">
                {verseItem.verse}
              </sup>
              <span className="bf-verse__text">{verseItem.text}</span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
